<div
  class="hstack gap-_5"
  *ngrxLet="entity | get : props.path | toString as name"
>
  <lui-avatar
    *ngIf="name; else emptyTmpl"
    [size]="props.size"
    [color]="name | stringColor"
  >
    {{ name | initials }}
  </lui-avatar>
  <span *ngIf="!props.initialsOnly">{{ name }}</span>

  <ng-template #emptyTmpl> - </ng-template>
</div>
